/**
 * 取消订单
 */
import React from 'react';
import styles from './index.module.scss';
import PropTypes from 'prop-types';
import { XInput, XOKButton, XCancelButton } from '@/components/xqxc_ui';
import { connect } from 'react-redux';
import TableList from './components/TableList';
import model from '@/reducers/finance/platformsubsidy/model';
import KeepAlive from '@/routes/KeepAlive';
import { SearchBox, SearchItem } from '@/components/Layout';
import { autoPageNum, autopageSize } from '@/assets/config';

class Main extends React.Component {

    state = {
        recordNo: undefined,
        relationNo: undefined,
        pageNum: 1,
        pageSize: 10,
    }

    // 查询
    _searchHandle = (useCache) => {
        const { recordNo, relationNo, pageNum, pageSize } = this.state;
        this.searchCache = {
            recordNumber: recordNo,
            associatedNumber: relationNo,
            pageNum: useCache == 'useCache' ? pageNum : autoPageNum,
            pageSize: useCache == 'useCache' ? pageSize : autopageSize,
        };
        this.props.getCancelOrderList(this.searchCache);
        KeepAlive.saveCache({ ...this.state, pageNum: this.searchCache.pageNum, pageSize: this.searchCache.pageSize }); // 【第3步，缓存查询状态】
    }

    // 重置
    _resetHandle = () => {
        this.setState({ recordNo: undefined, relationNo: undefined, pageNum: 1, pageSize: 10 }, () => {
            KeepAlive.saveResetFunc(this._searchHandle);
        });
    }

    // 表格分页
    _paginationChange = (pageSize, pageNum) => {
        this.setState({ pageNum, pageSize }, () => {
            this._searchHandle('useCache');
        });
    }

    render() {
        const { recordNo, relationNo } = this.state;
        const { cancelOrderList } = this.props;
        return (
            <KeepAlive render={(state) => {
                if (!this.state.__aliveInit) {
                    this.setState({ ...state, __aliveInit: true }, () => {
                        this._searchHandle('useCache'); // 【第1步：调用查询接口初始化数据】
                    });
                }
            }}>
                <div className={styles.flexBoxContainer}>
                    <SearchBox>
                        <SearchItem>
                            <XInput
                                inputStyle={{ width: '200px' }}
                                label='记录流水号'
                                placeholder='请输入'
                                value={recordNo}
                                bindThis={this}
                                bindName='recordNo'
                            />
                        </SearchItem>
                        <SearchItem>
                            <XInput
                                inputStyle={{ width: '200px' }}
                                label='关联单号'
                                placeholder='请输入'
                                value={relationNo}
                                bindThis={this}
                                bindName='relationNo'
                            />
                        </SearchItem>
                        <SearchItem>
                            <XOKButton
                                style={{ marginLeft: '20px', width: '60px' }}
                                label='查询'
                                onClick={this._searchHandle}
                            />
                            <XCancelButton
                                style={{ marginLeft: '20px', width: '60px' }}
                                label='重置'
                                onClick={this._resetHandle}
                            />
                        </SearchItem>
                    </SearchBox>
                    <TableList renderData={cancelOrderList} paginationChange={this._paginationChange} />
                </div>
            </KeepAlive>
        );
    }
}

Main.propTypes = {
    history: PropTypes.object,

    getCancelOrderList: PropTypes.func,
    cancelOrderList: PropTypes.object,
};
const mapStateToProps = (state) => ({
    cancelOrderList: state.platformsubsidy.cancelOrderList,
});

export default connect(mapStateToProps, { ...model.actions })(Main);